import API from "flux/api/api"
import React from "react"
import PropTypes from "prop-types"
import AddressAutocomplete from "components/admin/address_autocomplete"
import LocationMap from "components/shared/location_map"
import { SavedBadge } from "components/shared/saved_badge"
import RegistrationsPropTypes from "utils/prop_types"

class EventLocation extends React.Component {
  static propTypes = {
    eventId: PropTypes.number.isRequired,
    initialEventLocation: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
      campusId: PropTypes.number,
      addressData: PropTypes.object,
      subpremise: PropTypes.string,
      url: PropTypes.string,
      locationType: PropTypes.string,
      locationTypeId: PropTypes.number
    }),
    location: RegistrationsPropTypes.Location
  }

  constructor(props) {
    super(props)

    this.state = {
      campuses: [],
      loadingCampuses: true,
      savedSuccessfully: false,
      eventLocation: this.props.initialEventLocation,
      showLatLongFields: false
    }
  }

  componentDidMount() {
    API.getAll(`/campuses?order=name`, { perPage: 100 }).then(response =>
      this.setState({ campuses: response.data, loadingCampuses: false })
    )
  }

  render() {
    const { loadingCampuses, savedSuccessfully, eventLocation } = this.state

    const { campusId } = eventLocation || {}
    const campusIsSelected = campusId > 0
    const otherIsSelected = campusId == null && eventLocation != null

    return (
      <div>
        <div className="pane">
          <div className="pane__header d-f ai-c jc-sb p-r">
            <label htmlFor="detail-location" className="pane__title">
              Location
            </label>
            {savedSuccessfully ? <SavedBadge /> : null}
          </div>
          <div className="p-2">
            {loadingCampuses ? (
              <p>Loading...</p>
            ) : (
              <div>
                {this.renderCampusSelect()}
                {campusIsSelected && this.renderCampusDetail()}
                {otherIsSelected && this.renderOtherDetail()}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  renderSubpremiseInput = () => {
    const {
      eventLocation: { campusId, subpremise }
    } = this.state

    return (
      <div className="pt-1">
        <input
          type="text"
          key={campusId}
          placeholder="Unit, room, building (optional)"
          aria-label="Unit, room, building (optional)"
          defaultValue={subpremise}
          onChange={this.handleSubpremiseChange}
        />
      </div>
    )
  }

  renderNameInput = () => {
    const {
      eventLocation: { name }
    } = this.state

    return (
      <div>
        <input
          type="text"
          placeholder="Location name"
          defaultValue={name}
          onChange={this.handleNameChange}
        />
      </div>
    )
  }

  renderSaveButton = () => {
    return (
      <button
        className="btn-solid interaction sm mt-1 w-100% jc-c"
        onClick={this.updateEventLocation}
      >
        Save
      </button>
    )
  }

  renderMap = () => {
    return (
      <div className="pt-1">
        <LocationMap
          location={this.state.eventLocation}
          showMap={true}
          disableDefaultUIControls={true}
        />
      </div>
    )
  }

  renderCampusDetail = () => {
    return (
      <div>
        {this.renderSubpremiseInput()}
        {this.renderSaveButton()}
        {this.renderMap()}
      </div>
    )
  }

  renderCampusSelect = () => {
    const { campuses, eventLocation } = this.state
    const { campusId, id } = eventLocation || {}

    return (
      <select
        id="detail-location"
        className="select"
        value={id && campusId == null ? "0" : campusId}
        onChange={this.handleCampusSelect}
      >
        <option value="-1">Not specified</option>
        {campuses.map(campus => (
          <option key={campus.id} value={campus.id}>
            {campus.attributes.name}
          </option>
        ))}
        <option key="0" value="0">
          Other...
        </option>
      </select>
    )
  }

  renderOtherDetail = () => {
    const {
      eventLocation: { locationTypeId }
    } = this.state

    return (
      <div>
        <label htmlFor="detail-location-type" className="mt-2">
          Location Type
        </label>
        <select
          id="detail-location-type"
          className="select"
          value={locationTypeId}
          onChange={this.handleLocationTypeChange}
        >
          <option key="0" value="0">
            Street address
          </option>
          <option key="1" value="1">
            Latitude and longitude
          </option>
          <option key="2" value="2">
            Online
          </option>
        </select>
        <label htmlFor="details" className="mt-2">
          Details
        </label>
        {locationTypeId == 0 && this.renderAddressFields()}
        {locationTypeId == 1 && this.renderLatLongFields()}
        {locationTypeId == 2 && this.renderUrlFields()}
      </div>
    )
  }

  renderAddressFields = () => {
    const {
      eventLocation: { formattedAddress }
    } = this.state

    return (
      <div>
        {this.renderNameInput()}
        <div className="pt-1">
          <AddressAutocomplete
            formattedAddress={formattedAddress}
            location={{}}
            onChange={this.handleAddressChange}
          />
        </div>
        {this.renderSubpremiseInput()}
        {this.renderSaveButton()}
        {this.renderMap()}
      </div>
    )
  }

  renderLatLongFields = () => {
    const {
      eventLocation: { latitude, longitude }
    } = this.state

    return (
      <div>
        {this.renderNameInput()}
        {this.renderSubpremiseInput()}
        <div className="pt-1">
          <input
            type="text"
            placeholder="Latitude"
            defaultValue={latitude}
            onChange={this.handleLatChange}
          />
        </div>
        <div className="pt-1">
          <input
            type="text"
            placeholder="Longitude"
            defaultValue={longitude}
            onChange={this.handleLongChange}
          />
        </div>
        {this.renderSaveButton()}
        {this.renderMap()}
      </div>
    )
  }

  renderUrlFields = () => {
    const {
      eventLocation: { url }
    } = this.state

    return (
      <div>
        {this.renderNameInput()}
        <div className="pt-1">
          <input
            type="text"
            placeholder="https://www.planningcenter.com"
            defaultValue={url}
            onChange={this.handleUrlChange}
          />
        </div>
        {this.renderSaveButton()}
      </div>
    )
  }

  handleAddressChange = ({ locationData, formattedAddress }) => {
    const { eventLocation } = this.state
    let attributes = {}

    clearTimeout(this.addressChangeTimer)

    if (typeof locationData !== "undefined" && typeof locationData.address_data !== "undefined") {
      attributes.eventLocation = {
        ...eventLocation,
        addressData: locationData.address_data,
        latitude: locationData.latitude,
        longitude: locationData.longitude
      }
    } else {
      attributes.eventLocation = {
        ...eventLocation,
        addressData: []
      }
    }

    if (typeof formattedAddress !== "undefined") {
      attributes.eventLocation = {
        ...attributes.eventLocation,
        formattedAddress
      }
    }

    this.addressChangeTimer = setTimeout(() => {
      this.setState({
        eventLocation: { ...eventLocation, ...attributes.eventLocation }
      })
    }, 500)
  }

  handleUrlChange = event => {
    const { eventLocation } = this.state
    const url = event.target.value

    this.setState({ eventLocation: { ...eventLocation, url } })
  }

  handleLatChange = event => {
    const { eventLocation } = this.state
    const latitude = event.target.value

    clearTimeout(this.latChangeTimer)
    this.latChangeTimer = setTimeout(() => {
      this.setState({ eventLocation: { ...eventLocation, latitude } })
    })
  }

  handleLongChange = event => {
    const { eventLocation } = this.state
    const longitude = event.target.value

    clearTimeout(this.longChangeTimer)
    this.longChangeTimer = setTimeout(() => {
      this.setState({ eventLocation: { ...eventLocation, longitude } })
    })
  }

  handleLocationTypeChange = event => {
    const { eventLocation } = this.state
    const locationTypeId = event.target.value
    let attributes = {
      latitude: null,
      longitude: null,
      url: "",
      subpremise: "",
      addressData: [],
      formattedAddress: ""
    }

    this.setState({
      eventLocation: { ...eventLocation, ...attributes, locationTypeId }
    })
  }

  handleNameChange = event => {
    const { eventLocation } = this.state
    const name = event.target.value

    clearTimeout(this.nameChangeTimer)
    this.nameChangeTimer = setTimeout(() => {
      this.setState({ eventLocation: { ...eventLocation, name } })
    }, 500)
  }

  handleSubpremiseChange = event => {
    const { eventLocation } = this.state
    const subpremise = event.target.value

    this.setState({ eventLocation: { ...eventLocation, subpremise } })
  }

  updateEvent = params => {
    this.setState({ savedSuccessfully: false })

    fetch(`/signups/${this.props.eventId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": $.rails.csrfToken()
      },
      credentials: "include",
      body: JSON.stringify({ event: params })
    })
      .then(resp => resp.json())
      .then(resp => {
        if (resp.errors) {
          alertModal({
            title: "An error occured",
            text: resp.error_messages.join(", "),
            type: "error",
            confirmButtonText: "ok"
          })
        } else {
          this.setState({
            savedSuccessfully: true,
            eventLocation: resp.event.eventLocation
          })
        }
      })
      .catch(resp => Bugsnag.notifyException(resp, "EventSettingsError"))
  }

  handleCampusSelect = event => {
    const { eventLocation } = this.state
    const { id } = eventLocation || {}
    const {
      target: { value }
    } = event
    const campusId = value == "0" ? null : value
    const locationTypeId = 0

    if (campusId == "-1") {
      this.destroyEventLocation()
    } else {
      this.setState({ eventLocation: { campusId, id, locationTypeId } }, () => {
        if (parseInt(campusId) > 0) {
          this.updateEventLocation()
        }
      })
    }
  }

  destroyEventLocation = () => {
    const {
      eventLocation: { id }
    } = this.state

    this.setState({ eventLocation: null }, () => {
      this.updateEvent({ event_location_attributes: { id, _destroy: true } })
    })
  }

  updateEventLocation = () => {
    const { eventLocation } = this.state

    const attributes = {
      id: eventLocation.id,
      location_type: parseInt(eventLocation.locationTypeId),
      name: eventLocation.name || "",
      campus_id: parseInt(eventLocation.campusId) > 0 ? eventLocation.campusId : null,
      subpremise: eventLocation.subpremise || "",
      address_data: eventLocation.addressData || {},
      latitude: eventLocation.latitude || null,
      longitude: eventLocation.longitude || null,
      url: eventLocation.url || ""
    }

    const { campus_id, name, address_data, latitude, longitude } = attributes

    if (campus_id != null || name != "" || latitude || longitude || address_data) {
      this.updateEvent({
        event_location_attributes: attributes
      })
    }
  }
}

export default EventLocation
